export async function fetchMetaSales() {
  const response = await fetch('/api/dashboard/meta-sales', {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(`Meta sales API: HTTP ${response.status}`);
  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    throw new Error('Meta sales API no está disponible en este servidor.');
  }
  return response.json();
}

export async function getAdminSession() {
  return adminFetch('/api/admin/session');
}

export async function loginAdmin(password) {
  return adminFetch('/api/admin/session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });
}

export async function logoutAdmin() {
  return adminFetch('/api/admin/session', { method: 'DELETE' });
}

export async function getMetaConfigStatus() {
  return adminFetch('/api/admin/config/status');
}

export async function testMetaConnection() {
  return adminFetch('/api/admin/meta-connection', { method: 'POST' });
}

export async function getMetaEventDetail(deliveryId) {
  const response = await fetch(`/api/dashboard/meta-events/${encodeURIComponent(deliveryId)}`, {
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  });
  const contentType = response.headers.get('content-type') || '';
  const data = contentType.includes('application/json')
    ? await response.json()
    : { error: `HTTP ${response.status}` };
  if (!response.ok) {
    const error = new Error(data.error || `HTTP ${response.status}`);
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
}

export async function retryMetaEvent(deliveryId) {
  return adminFetch(`/api/admin/meta-events/${encodeURIComponent(deliveryId)}/retry`, {
    method: 'POST',
  });
}

export async function updateSaleReview(saleId, patch) {
  return adminFetch(`/api/admin/sales/${encodeURIComponent(saleId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patch),
  });
}

async function adminFetch(url, options = {}) {
  const response = await fetch(url, {
    credentials: 'same-origin',
    ...options,
  });
  const contentType = response.headers.get('content-type') || '';
  const data = contentType.includes('application/json')
    ? await response.json()
    : { error: `HTTP ${response.status}` };
  if (!response.ok) {
    const error = new Error(data.error || data.errorMessage || `HTTP ${response.status}`);
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
}
